import {observer} from 'mobx-react';
import React from 'react';

import {Modal} from '@udemy/react-dialog-components';

import {CreateModalStore} from 'src/stores/create-modal-store';

import styles from './create-modal.module.less';
import {ClientCreatedStep} from './steps/client-created-step.react-component';
import {ClientNameStep} from './steps/client-name-step.react-component';
import {ScopeSelectionStep} from './steps/scope-selection-step.react-component';

export const CreateModal = observer(({createModalStore}: {createModalStore: CreateModalStore}) => {
    return (
        <Modal
            title="New API Client"
            isOpen={createModalStore.isOpen}
            onClose={() => createModalStore.close()}
            className={styles['create-modal-container']}
        >
            {createModalStore.activeStep === 'clientName' && (
                <ClientNameStep store={createModalStore} />
            )}
            {createModalStore.activeStep === 'scopeSelection' && (
                <ScopeSelectionStep store={createModalStore} />
            )}
            {createModalStore.activeStep === 'clientCreated' && (
                <ClientCreatedStep store={createModalStore} />
            )}
        </Modal>
    );
});
